<template>
  <div class="myTransfer_box">
    <el-dialog
      title="服务支持管理"
      :visible.sync="dialogVisible"
      width="900px"
      :before-close="handleClose"
    >
      <el-transfer
        v-loading="loading"
        filterable
        :filter-method="filterMethod"
        :props="{
          key: 'userId',
          label: 'nickName',
          pinyin: 'userName',
        }"
        :titles="['选择用户', '已选择用户']"
        filter-placeholder="请输入搜索内容"
        v-model="value"
        :data="data"
      >
      </el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleClose">取消</el-button>
        <el-button size="medium" type="primary" @click="handleAffirm"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  allCompanyUserWithDept,
  getSupportUserList,
  addSupportUsers,
} from "@/api/refund/index.js";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      data: [],
      value: [],
      transferData: [],
      filterMethod(query, item) {
        return item.nickName.indexOf(query) > -1;
      },
    };
  },
  methods: {
    init() {
      this.dialogVisible = true;
      this.loading = true;
      this.awaitDataMeth().then((result) => {
        this.data = result[0].data || [];
        let datas = result[1].data.records || [];
        this.value = datas.map((item) => {
          return item.userId;
        });
        this.transferData = datas.map((item) => {
          return item.userId;
        });
        this.loading = false;
      });
    },
    awaitDataMeth() {
      const allCompanyUserApi = allCompanyUserWithDept();
      const supportUserApi = getSupportUserList({ page: 1, limit: -1 });
      return Promise.all([allCompanyUserApi, supportUserApi]);
    },
    handleAffirm() {
      // let arr = [];
      // this.value.forEach((item) => {
      //   if (!this.transferData.includes(item)) {
      //     arr.push(item);
      //   }
      // });
      // let userIds = arr.join(",");
      let userIds = this.value.join(",");
      addSupportUsers({ userIds }).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.dialogVisible = false;
          this.$parent.refresh()
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.myTransfer_box {
  ::v-deep .el-transfer {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-transfer-panel {
    width: 300px;
    height: 600px;
  }
  ::v-deep .el-transfer-panel__body {
    width: 300px;
    height: 542px;
  }
  ::v-deep .el-transfer-panel__list {
    width: 300px;
    height: 496px;
  }
}
</style>